import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ScrollManager } from "@/nav";
import { LangProvider } from "@/i18n";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CloudBackdrop from "@/components/CloudBackdrop";
import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream p-8 text-center">
          <div>
            <p className="font-display text-2xl font-semibold text-forest">Something went wrong.</p>
            <p className="text-forest/70 mt-2">Please refresh the page — we’ll be right here!</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <LangProvider>
        <BrowserRouter>
          <ScrollManager />
          <div className="App relative isolate bg-cream min-h-screen">
            <CloudBackdrop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
          </div>
        </BrowserRouter>
      </LangProvider>
    </ErrorBoundary>
  );
}

export default App;
